// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cgv-page {
    font-family: Arial, sans-serif;
    line-height: 1.6;
    margin: 20px;
}

.cgv-container {
    max-width: 800px;
    margin: auto;
}

.cgv-title-h1 {
    color: #FFA500;
}

.cgv-title-h2 {
    color: #FFA500;
}

.cgv-title-h3 {
    color: #FFA500;
}

.cgv-custom-container {
    max-width: 800px;
    margin: auto;
}

.cgv-custom-paragraph {
    margin-bottom: 1em;
}

.cgv-custom-ul {
    list-style-type: decimal;
    margin-left: 20px;
}

.cgv-custom-title-h1 {
    color: #FFA500;
}

.cgv-custom-title-h2 {
    color: #FFA500;
}

.cgv-custom-title-h3 {
    color: #FFA500;
}`, "",{"version":3,"sources":["webpack://./src/pages/CGVAccept/CGVAccept.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".cgv-page {\n    font-family: Arial, sans-serif;\n    line-height: 1.6;\n    margin: 20px;\n}\n\n.cgv-container {\n    max-width: 800px;\n    margin: auto;\n}\n\n.cgv-title-h1 {\n    color: #FFA500;\n}\n\n.cgv-title-h2 {\n    color: #FFA500;\n}\n\n.cgv-title-h3 {\n    color: #FFA500;\n}\n\n.cgv-custom-container {\n    max-width: 800px;\n    margin: auto;\n}\n\n.cgv-custom-paragraph {\n    margin-bottom: 1em;\n}\n\n.cgv-custom-ul {\n    list-style-type: decimal;\n    margin-left: 20px;\n}\n\n.cgv-custom-title-h1 {\n    color: #FFA500;\n}\n\n.cgv-custom-title-h2 {\n    color: #FFA500;\n}\n\n.cgv-custom-title-h3 {\n    color: #FFA500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
